import { useSelector } from 'react-redux';
import { PluginStatusChecker } from '../../vayu-sites/template/PluginStatusChecker';

const useProLicense = () => {
	const pluginStatus = PluginStatusChecker('vayu-blocks-pro/vayu-blocks-pro');
	const license = useSelector((state) => state.licenseActivate);
	const isProInstalled = pluginStatus?.isInstalled;
	const isProActive = pluginStatus?.isActive;
	const isLicensed = license?.status === true;

	const isProEnabled = isProInstalled && isProActive && isLicensed;
   
	return {
		isProEnabled,
		isProInstalled,
		isProActive,
		isLicensed,
	};
};

export default useProLicense;
